// @flow
import React, { Component } from 'react';
import MenuHeader from '../components/MenuHeader/MenuHeader';
import Footer from '../components/Footer/Footer';
import Search from './components/Search/Search';
import UserList from './components/UserList/UsersList';
import UserSettings from '../UserSettings/UserSettings';

class AdminUsers extends Component<Object, {
 selectedUser: string,
 filter: string,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      selectedUser: '',
      filter: '',
    };
  }

  selectUser(user: string) {
    this.setState({ selectedUser: user });
  }

  changeFilter(value: string) {
    this.setState({ filter: value, selectedUser: '' });
  }

  render() {
    return (<div>
      <MenuHeader active="users" />
      <div className="container">
        <Search onChange={(v: string) => this.changeFilter(v)} />
        <UserList onUserSelect={user => this.selectUser(user)} filter={this.state.filter} />
      </div>
      <UserSettings userID={this.state.selectedUser} />
      <Footer />
    </div>);
  }
}

export default AdminUsers;



// WEBPACK FOOTER //
// ./src/scenes/Users/Users.js